import { Card, Text, Title } from 'components';
import React from 'react';

const PrivacyNoticeSalamanca = () => (
  <Card
    style={{
      textAlign: 'justify',
      padding: '2rem 4rem',
    }}
  >
    <Title $accent style={{ textAlign: 'center' }}>
      AVISO DE PRIVACIDAD
    </Title>
    <br />
    <Text forwardedAs="p">

      Aviso de Privacidad. Los datos personales recabados en el presente serán protegidos,
      incorporados y tratados en las distintas bases de datos personales con la única determinada,
      explicita y legítima finalidad para lo que fueron recabados.
      Ninguna dependencia podrá requerir información que exceda los fines para los cuales se obtuvo,
      así como tampoco podrá usarse dicha información para finalidades distintas a los trámites
      administrativos que conlleva la presente acta de infracción.
      A efecto de cumplir con la ley en materia, debiendo ser la información identificable,
      exacta, adecuada, pertinente y no excesiva. Lo anterior a efecto de no vulnerar lo establecido
      en los artículos 1, 2, 3, 8 de la Ley de Protección de Datos Personales
      en Posesión de Sujetos Obligados para el Estado de Guanajuato.

    </Text>

  </Card>
);

export default PrivacyNoticeSalamanca;
